<div class="row" style="min-height: 200px;">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="inline-block deviceOptionsHeader">
          <sb-icon class="red" icon="attention"></sb-icon>&nbsp;
        </div>
        <div class="red inline-block deviceOptionsHeader">
          &nbsp;{{'lang.device.exitPlayer' | translate}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tablewrap">
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100">{{'lang.globals.deviceId' | translate}}</p>
              <p class="w-100 tr mr-2"><b>{{device.id}}</b></p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100">{{'lang.device.exitPlayerMessage' | translate}}</p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-center header">
              <button class="btn btn-success" (click)="submit()">
                <sb-icon icon="checked"></sb-icon>&nbsp;{{'lang.globals.yes' | translate}}
              </button>
              <button class="btn btn-danger" (click)="reject()">
                <sb-icon icon="cancel"></sb-icon>&nbsp;{{'lang.globals.no' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
